const environment = {
  apiUrl: "http://localhost:3001",
  graphql: "http://localhost:3001/graphql",
  joinWaitlistTempId: "100",
  joinSubscriptionTempId: "100",
  publishableKey:
    "pk_test_51N5RwtFMwL8QZRPTX7xohghqvcavgyEvsSWcsucw0zTtiJsx8ElhsSgTTdqAwyJWgk63BfEOmqPPnLtuL2nHIo3X00TLF8PxZ3",

  accessKeyId: "AKIASYX7YD3NYLHERWWV",
  secretAccessKey: "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",
  googleAPIKEY: "AIzaSyDDVEcBhn_h6DSsugydMYQaNqXrU4ZZdl0",
};

export default environment;
